import VueAvatar from '@/components/vue-avatar-editor/VueAvatar.vue'
    import VueAvatarScale from '@/components/vue-avatar-editor/VueAvatarScale.vue'
    import { mapGetters } from 'vuex';
    export default 
    {
        props: ['booking_id', 'multi_book_id', 'show_upload_picture'],
        name: "service_image_crop_model",
        components: 
        {
            VueAvatar,
            VueAvatarScale
        },   
        data: function () 
        {
            return {
                images_list: [],
                imageBlock: 'col-12',
                editImageBlock: '',
                hideOrShowEditImageBlock: true,
                hideOrShowEditButton: false,
                imgToCrop: '',
                image_public_id: 0,
                thumbnail_public_id: 0,
                booking_service_image_id: 0,
                warning_file: false,
                upload_file: false,
                upload_success: false,
                upload_fail: false,
                isDragging: false,
                show_upload_pictures_screen:false,
                dragCount: 0,
                status_processing: 'Uploading...',
                status_success: 'Successfully Uploaded.',
                status_failed: 'Failed to Uploaded.',
                warning_file_message: 'Only JPG, JPEG and PNG image formats with max 5MB size are accepted.'
            }
        },
        mounted () 
        {
            this.show_upload_pictures_screen = this.show_upload_picture;
            this.get_customer_images()
        },
        computed: {
            ...mapGetters(["get_services", "get_booking_images", "upload_image"])
        },
        watch: {
            warning_file: function (status) {
                if(status == true) setTimeout(() => this.warning_file = false, 3000);
            },
            upload_success: function (status) {
                if(status == true) setTimeout(() => this.upload_success = false, 3000);
            },
            upload_fail: function (status) {
                if(status == true) setTimeout(() => this.upload_fail = false, 3000);
            },
            upload_file: function (status) 
            {
                var buttonsToDisable = document.getElementsByClassName('disableOnProcess');
                if(status == true) 
                    buttonsToDisable.forEach(btnElem => { btnElem.disabled = true });
                else if(status == false) 
                    buttonsToDisable.forEach(btnElem => { btnElem.disabled = false });
            },
        },
        methods: {
            async get_customer_images() 
            {
                await this.$store.dispatch('get_booking_details',[this.$store.state.api, this.booking_id, this.multi_book_id])
                await this.$store.dispatch('get_customer_images',[this.$store.state.api,[this.$store.state.services_data.services[0].cust_id,this.booking_id,this.multi_book_id]])
                this.images_list = this.get_booking_images;
            },
            onChangeScale (scale) 
            {
                this.$refs.vueavatar.changeScale(scale)
            },
            uploadImageButton(upload) 
            {
                this.show_status(false, false, false, false)
                var target_img = upload.target.files[0];
                this.upload_new_image(target_img);
            },
            upload_new_image(target_img)
            {
                if(typeof target_img === 'undefined') return;
                const acceptedImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
                if(!acceptedImageTypes.includes(target_img['type']))
                {
                    this.warning_file_message = 'Only JPG, JPEG and PNG image formats are accepted.';
                    this.show_status(true, false, false, false)
                    return;
                }
                this.statusUpdate('Uploading Image...', 'Image Uploaded Successfully.', 'Failed To Upload Image.')
                var target_img_size = Math.round(( target_img.size / 1024));
                if(target_img != null && target_img_size <= 5120)
                {
                    this.imgToBase64(target_img).then(base64_img => {
                        let upload_img = [{"image":base64_img}]
                        this.sendImageToApi(upload_img, this.Constants.UPLOAED_IMAGE_FLAG) 
                    });
                }
                else if(target_img_size > 5120) 
                {
                    this.warning_file_message = 'Image size exceeds maximum limit 5MB.';
                    this.show_status(true, false, false, false)
                }
            },
            imgToBase64(file) {
                return new Promise(resolve => {
                    var reader = new FileReader();
                    reader.onload = function(event) { resolve(event.target.result); }
                    reader.readAsDataURL(file);
                });
            },
            cropImage()
            {
                var crop = this.$refs.vueavatar.getImage()
                if(crop != false)
                {
                    // let data = this.$refs.vueavatar.getImage().toDataURL();
                    // let w = window.open('about:blank');
                    // let image = new Image();
                    // image.src = data;
                    // setTimeout(function(){
                    // w.document.write(image.outerHTML);
                    // }, 0);
                    this.statusUpdate('Cropping Image...', 'Image Cropped Successfully.', 'Failed To Crop Image.')
                    let cropped_img = [{
                                        "image":this.$refs.vueavatar.getImage().toDataURL(),
                                        "image_public_id":this.image_public_id,
                                        "thumbnail_public_id":this.thumbnail_public_id,
                                        "booking_service_image_id":this.booking_service_image_id
                                    }]
                    this.sendImageToApi(cropped_img, this.Constants.CROP_IMAGE_FLAG)
                }
            }, 
            async sendImageToApi(img_obj, upload_type_flag) 
            {
                this.show_status(false, true, false, false)
                let _this = this;
                await  this.$store.dispatch('upload_image',[
                            this.$store.state.api,
                            img_obj, 
                            this.$store.state.services_data.services[0].cust_id,
                            _this.booking_id,
                            this.$store.state.user_id, 
                            upload_type_flag
                        ]);
                this.show_upload_pictures_screen = true;
                if(this.upload_image.status == this.Constants.IMAGE_UPLOAD_STATUS_SUCCESS)
                    this.show_status(false, false, true, false)
                else
                    this.show_status(false, false, false, true)
                this.get_customer_images();
                this.cancelImageButton();
            },   
            onImageReady(scale)
            {
                this.$refs.vueavatarscale.setScale(scale)
            },
            editImage(imageSource, image_public_id, thumbnail_public_id, booking_service_image_id) 
            {
                if (this.hideOrShowEditImageBlock == false)
                {
                    this.imgToCrop                  = imageSource;
                    this.image_public_id            = image_public_id;
                    this.thumbnail_public_id        = thumbnail_public_id;
                    this.booking_service_image_id   = booking_service_image_id;
                }              
            },
            auto_select_first_image() {
                if(this.images_list.length > 0)
                {
                    this.editImage(
                        this.images_list[0].image_url,
                        this.images_list[0].image_public_id,
                        this.images_list[0].thumbnail_public_id,
                        this.images_list[0].booking_service_image_id
                    )
                }
            },
            editImageButton() 
            {
                this.modelBlockDivision('col-6', 'col-6', false, true)
                this.auto_select_first_image();
            },
            cancelImageButton() 
            {
                this.modelBlockDivision('col-12', '', true, false);
            },
            modelBlockDivision(imageBlock, editImageBlock, hideOrShowEditImageBlock, hideOrShowEditButton) 
            {
                this.imageBlock                 = imageBlock;
                this.editImageBlock             = editImageBlock;
                this.hideOrShowEditImageBlock   = hideOrShowEditImageBlock;
                this.hideOrShowEditButton       = hideOrShowEditButton;
                this.imgToCrop                  = '';
            },
            show_status(warning_file, upload_file, upload_success, upload_fail)
            {
                this.warning_file   = warning_file;
                this.upload_file    = upload_file;
                this.upload_success = upload_success;
                this.upload_fail    = upload_fail;
            },
            
            OnDragEnter(img_obj) {
                img_obj.preventDefault();            
                this.dragCount++;
                this.isDragging = true;
                return false;
            },
            OnDragLeave(img_obj) {
                img_obj.preventDefault();
                this.dragCount--;
                if (this.dragCount <= 0)
                    this.isDragging = false;
            },
            onDrop(img_obj) {
                img_obj.preventDefault();
                img_obj.stopPropagation();
                this.isDragging = false;
                const files = img_obj.dataTransfer.files[0];
                this.upload_new_image(files)
                // Array.from(files).forEach(file => this.upload_new_image(file));
            },
            deleteImage(image_public_id, thumbnail_public_id, booking_service_image_id) 
            {
                this.statusUpdate('Deleting Image...', 'Image Deleted Successfully.', 'Failed To Delete Image.')
                let delete_img = [{
                    "image_public_id":image_public_id,
                    "thumbnail_public_id":thumbnail_public_id,
                    "booking_service_image_id":booking_service_image_id
                }]
                this.sendImageToApi(delete_img, this.Constants.DELETE_IMAGE_FLAG)
            },

            statusUpdate(status_processing, status_success, status_failed)
            {
                this.status_processing  = status_processing;
                this.status_success     = status_success;
                this.status_failed      = status_failed;
            }
        }
    }